/**
 * Single source of truth for DSOK color fields.
 * Used by customer-detail colors and system settings (new customer defaults)
 * so both always show the same set of fields. Each page uses its own
 * data source and save logic (separate controls).
 */

export const COLOR_FIELD_KEYS = [
  "mainColor",
  "buttonColor",
  "buttonBgColor",
  "orderButtonBackgroundColor",
  "orderButtonTextColor",
  "iconColor",
  "textColor",
  "secondaryColor",
  "titleColor",
  "darkerTextColor",
  "darkerSecondaryTextColor",
  "accentColor",
  "hoverColor",
  "borderColor",
  "backgroundColor",
  "lightBackgroundColor",
  "darkerBackgroundColor",
  "spinnerColor",
];

const ORDER_BUTTON_DEFAULTS = {
  orderButtonBackgroundColor: "#c0844d",
  orderButtonTextColor: "#ffffff",
};
export const DEFAULT_COLORS = Object.fromEntries(
  COLOR_FIELD_KEYS.map((key) => [
    key,
    ORDER_BUTTON_DEFAULTS[key] !== undefined ? ORDER_BUTTON_DEFAULTS[key] : "",
  ])
);

/** Translation key for each field (pages.dsokDetails.colors.<key>) */
export function getColorLabelKey(key) {
  return `pages.dsokDetails.colors.${key}`;
}
